import { useEffect, useState } from 'react';
import { Box, Divider, Fade, IconButton, Modal, Paper, Typography } from '@mui/material';
import { TextWithLabelInline } from '@main/components';
import WdSvgIcon from '@main/core/WdSvgIcon';
import _ from 'lodash';

export const MongodbConnection = ({
  title,
  show = false,
  onHide = () => {},
  data = {},
  selected,
}) => {
  const [selectedData, setSelectedData] = useState(undefined);

  const handleCloseModal = () => {
    onHide();
  };

  useEffect(() => {
    if (selected === undefined || _.isEmpty(data)) return;
    const selectingData = data[selected] || {};
    setSelectedData(selectingData);
  }, [selected, data]);

  return (
    <Modal
      open={show}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      className="flex justify-center items-center overflow-scroll pt-32"
      onClose={handleCloseModal}
    >
      <Fade in={show}>
        <Box className="flex">
          <Paper
            className="flex flex-col relative"
            elevation={3}
            sx={{
              width: '42rem',
              minWidth: '48rem',
              minHeight: '20rem',
            }}
          >
            <div className="flex justify-end justify-items-end p-8 absolute top-0 right-0">
              <IconButton aria-label="close" size="small" onClick={handleCloseModal}>
                <WdSvgIcon className="text-32" size={24} color="action">
                  material-solid:close
                </WdSvgIcon>
              </IconButton>
            </div>
            <div className="container p-20">
              <Typography variant="h6" className="flex justify-center">
                {title}
              </Typography>
              <Typography className="flex justify-center pb-14 font-bold text-lg">{`"${selected}"`}</Typography>
              <Divider />
              <Box className="mx-24">
                {selectedData && <TextWithLabelInline label="Host" value={selectedData?.host} />}
                {selectedData && <TextWithLabelInline label="Puerto" value={selectedData?.port} />}
                {selectedData && (
                  <TextWithLabelInline
                    label="Nombre de base de datos"
                    value={selectedData?.dbAuthName}
                  />
                )}
                {selectedData && (
                  <TextWithLabelInline label="Usuario" value={selectedData?.username} />
                )}
                {selectedData && (
                  <TextWithLabelInline label="Contarseña" value={selectedData?.password} />
                )}
              </Box>
            </div>
          </Paper>
        </Box>
      </Fade>
    </Modal>
  );
};
